module.exports = __webpack_public_path__ + "static/media/download.9382ded6.svg";